import { render, staticRenderFns } from "./SubmitVectraitsData.vue?vue&type=template&id=501a2a95&scoped=true&"
import script from "./SubmitVectraitsData.vue?vue&type=script&lang=js&"
export * from "./SubmitVectraitsData.vue?vue&type=script&lang=js&"
import style0 from "./SubmitVectraitsData.vue?vue&type=style&index=0&id=501a2a95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a2a95",
  null
  
)

export default component.exports